import { StaticImageData } from 'next/image';
import mitchellMaddoxAvatar from '../../../public/webp/fromPNG/AlgeaTheme/mitchel-3.webp';
import {
  StyledStack,
  StyledQuote,
  StyledTestimonial,
  TestimonialWrapper,
  CustomerTestimonialSection,
} from './styles';

export const Testimonial = () => {
  return (
    <CustomerTestimonialSection width="normal">
      <StyledStack>
        <StyledQuote variant="display_sm">“</StyledQuote>
        <TestimonialWrapper>
          <StyledTestimonial
            name="Mitchell Maddox"
            positionInCompany="CEO of Woodland Russel"
            text={`
              The Rumble Fish development team is outstanding, some of the best 
              engineers we’ve worked with. Their level of engineering 
              intelligence allowed us to achieve all our goals. As a full-stack 
              development partner they have a high standard for code quality, 
              UX, communication, and all-around efficiency. They are one of our 
              go-to resources for all web and mobile development. Highly 
              recommended.
            `}
            avatarSrc={
              (mitchellMaddoxAvatar as unknown as StaticImageData)?.src
            }
          />
        </TestimonialWrapper>
      </StyledStack>
    </CustomerTestimonialSection>
  );
};
